import React from "react";
import SelectBox from "./SelectBox/SelectBox";
import CategoryTree from "./CategoryTree";

const JoinPosterAssortmentNavLeft = (props) => {
  const {
    shops,
    categories,
    selectedShopId,
    selectedCategoryId,
    onChangeShop,
    onToggleCategory,
    onSelectCategory,
  } = props;

  return (
    <div className="JoinPosterAssortmentNavLeft">
      <SelectBox
        selectBoxName="Магазин"
        items={shops}
        isWithCheckboxes={false}
        firstElIsAll={false}
        autoSelectFirst={true}
        className="JoinPosterSelectBox--page70"
        actionOnSelect={onChangeShop}
      />
      <CategoryTree
        categories={categories}
        selectedCategoryId={selectedCategoryId}
        selectedShopId={selectedShopId}
        onToggleCategory={onToggleCategory}
        onSelectCategory={onSelectCategory}
      />
    </div>
  );
};

export default JoinPosterAssortmentNavLeft;
